<template>
  <div>
    <el-card class="content-card">
      <div class="section-header">
        <h4>Order List</h4>
      </div>
      <el-divider></el-divider>
      <el-table :data="ordersData" style="width: 100%">
        <el-table-column prop="orderId" label="Order ID"></el-table-column>
        <el-table-column prop="amount" label="Amount"></el-table-column>
        <el-table-column prop="createdAt" label="Created At"></el-table-column>
        <el-table-column prop="orderStatus" label="Order Status">
          <template slot-scope="{ row }">
            <el-tag :type="getOrderStatusTag(row.orderStatus)">{{ row.orderStatus }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { customerOrdersList } from "@/api/orders";

export default {
  name: "OrderTable",
  data() {
    return {
      ordersData: [] // 存储订单数据
    };
  },
  async created() {
    await this.loadOrders();
  },
  methods: {
    async loadOrders() {
      try {
        const res = await customerOrdersList(); // 调用 API 获取数据
        console.log(res);

        if (res.body && res.body.items) {
          this.ordersData = res.body.items.map(order => ({
            orderId: order.order_no,
            amount: this.formatCurrency(order.amount),
            createdAt: new Date(order.created_at).toLocaleString(),
            orderStatus: this.mapOrderStatus(order.status)
          }));
        }
      } catch (error) {
        console.error("加载订单失败:", error);
      }
    },
    formatCurrency(amount) {
      return `¥${(amount / 100).toFixed(2)}`; // 转换为 `¥99.00` 格式
    },
    mapOrderStatus(status) {
      const statusMap = {
        pending: "Pending",
        completed: "Completed",
        cancelled: "Cancelled",
        canceled: "Cancelled",
        trial: "Trial",
        active: "Active",
        overdue: "Overdue",
        unpaid: "Unpaid",
        failed: "Failed"
      };
      return statusMap[status] || "Unknown";
    },

    getOrderStatusTag(status) {
      const tagMap = {
        Pending: "info",
        Completed: "success",
        Cancelled: "warning",
        Trial: "primary",
        Active: "success",
        Overdue: "danger",
        Unpaid: "warning",
        Failed: "danger",
        Unknown: "info"
      };
      return tagMap[status] || "info";
    }
  }
};
</script>

<style scoped>
.content-card {
  padding: 20px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header h4 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.el-table th {
  font-weight: bold;
  color: #666;
  text-align: left;
}

.el-table td {
  color: #333;
}
</style>